// ===========================================
// GeminiModal.js
// 童顏家行程日曆系統 - AI 小助理彈窗元件
//
// 版本：V1.01 | 2024-07-05 20:20:00
// 主要功能：顯示 Gemini AI 產生的文案、支援複製與錯誤提示
// 解決問題：讓用戶可快速取得 AI 產生的宣傳文案
//
// 版本紀錄：
// - V1.01 (2024-07-05): 初始版本，從 App.js 拆分
//
// 注意事項：
// - 僅負責顯示與互動，不處理 API 呼叫
// - 關聯檔案：App.js
// ===========================================
import React from 'react';

const GeminiModal = ({ config, onClose }) => { 
    const { isOpen, isLoading, content, error } = config;
    if (!isOpen) return null; 
    const handleCopy = () => { if(content) { navigator.clipboard.writeText(content).then(() => alert('文案已複製！')).catch(err => alert('複製失敗')); } }; 
    return ( 
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-[60]">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold">✨ AI 小助理</h3>
                    <button onClick={onClose} className="text-2xl">&times;</button>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg min-h-[200px] max-h-[40vh] overflow-y-auto">
                    {isLoading ? <p>AI思考中...</p> : error ? <p className="text-red-500">{error}</p> : <p className="whitespace-pre-wrap">{content}</p>}
                </div>
                <div className="mt-6 flex gap-4">
                    <button onClick={handleCopy} disabled={!content || isLoading} className="flex-1 bg-blue-600 text-white font-bold py-2 rounded-lg">複製</button>
                    <button onClick={onClose} className="flex-1 bg-gray-200 font-bold py-2 rounded-lg">關閉</button>
                </div>
            </div>
        </div>
    ); 
};

export default GeminiModal; 